import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { LocalAuthoritySection } from '../components/LocalAuthoritySection';
import { BlogSection } from '../components/BlogSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function HomePage() {
  useEffect(() => {
    document.title = 'Noord | Webdesign & Websites in Noord-Holland';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Noord Digital maakt professionele websites voor ondernemers in Noord-Holland. Webdesign, SEO en WordPress websites die klanten opleveren. Vraag een vrijblijvend gesprek aan.';
  }, []);
  return <main data-id="element-1096">
      <HeroSection data-id="element-1097" />
      <ProblemSection data-id="element-1098" />
      <ServicesSection data-id="element-1099" />
      <ProcessSection data-id="element-1100" />
      <LocalAuthoritySection data-id="element-1101" />
      <BlogSection data-id="element-1102" />
      <FinalCtaSection data-id="element-1103" />
    </main>;
}